import $ from "dabbyjs/src/core/dabby/dabby.js";
import "dabbyjs/src/attributes/data/data.js";
import "dabbyjs/src/events/on/on.js";
import "dabbyjs/src/manipulation/text/text.js";
import "dabbyjs/src/traversal/children/children.js";
import "dabbyjs/src/attributes/attr/attr.js";
import "dabbyjs/src/attributes/val/val.js";
import "dabbyjs/src/attributes/css/css.js";
 
export default obj => {
	obj.each(function () {
		const $this = $(this),
			filter = $("#" + $this.data("filter")),
			groups = filter.children("optgroup"),
			update = () => {
				const selected = $("option:checked", $this);
				groups.each(function () {
					const $this = $(this),
						label = $this.attr("label"),
						value = selected.val() === "" ? null : selected.text();
					$this.css("display", value !== null && label !== value ? "none" : "");
				});
				filter.val("");
			};

		// update onload
		$this.on("change", update);
		update();
	});
}